/**
 *
 */
export interface ListenerContainer {
  /**
 *
 */
  priority: number;
  /**
 *
 */
  fn: EventListener;
}

/**
 *
 */
export class EventLoaderStore {
  onReadyQueue: ListenerContainer[] = [];

  onReadyEvent?: Event;

  get onReadyFired(): boolean {
    return !!this.onReadyEvent;
  }

  onLoadQueue: ListenerContainer[] = [];

  onLoadEvent?: Event;

  get onLoadFired(): boolean {
    return !!this.onLoadEvent;
  }

  allPreloadScriptsLoadedQueue: ListenerContainer[] = [];

  allPreloadScriptsLoadedEvent?: Event;

  get allPreloadScriptsLoadedFired(): boolean {
    return !!this.allPreloadScriptsLoadedEvent;
  }

  allJavascriptLoadedQueue: ListenerContainer[] = [];

  allJavascriptLoadedComplete?: boolean;

  allJavascriptLoadedEvent?: unknown;

  get allJavascriptLoadedFired(): boolean {
    return !!this.allJavascriptLoadedEvent;
  }
}
